import React, { Component } from "react";
import { Input, Dropdown, TextArea } from "semantic-ui-react";
import {CardNumberElement,CardExpiryElement, CardCvcElement} from 'react-stripe-elements';

/**
 * DO NOT USE
 * FOR FORMS USE FORMIK AND SHARED COMPONENTS CREATED IN GENBOOK COMPONENTS PACKAGE
 */
export default class TextInput extends Component {
  constructor(props) {
    super(props);
  }

  renderInput = () => {
    let { title, fieldclasses } = this.props;
    return (
      <div className={fieldclasses || "field"}>
        {title ? <h5>{title}</h5> : ""}
        <Input {...this.props} />
      </div>
    );
  };

  renderDropdown = () => {
    //logger.info(this.props);
    let { title, fieldclasses, label } = this.props;
    return (
      <div className={fieldclasses || "field"}>
        {title ? <h5>{title}</h5> : ""}
        {label ? <span className={label} /> : ""}
        <Dropdown {...this.props}>{this.props.children}</Dropdown>
      </div>
    );
  };

  renderTextArea = () => {
    //logger.info(this.props);
    let { title, fieldclasses } = this.props;
    return (
      <div className={fieldclasses || "field"}>
        {title ? <h5>{title}</h5> : ""}
        <TextArea {...this.props}>{this.props.children}</TextArea>
      </div>
    );
  };

  renderToggle = () => {};

  render() {
    let itemToRender = "";
    let { type } = this.props;
    if (type == "input" || type == "text" || type == "email" || type == "tel") {
      //placeholder,value,focus,icon,classname
      itemToRender = this.renderInput(...this.props);
    } else if (type == "dropdown") {
      //text,className
      itemToRender = this.renderDropdown(...this.props);
    } else if (type == "toggle") {
      itemToRender = this.renderToggle(...this.props);
    } else if (type == "textarea") {
      itemToRender = this.renderTextArea(...this.props);
    } else {
      logger.error("the TYPE prop is mandatory", this.props);
    }

    return itemToRender;
  }
}
